import { fixKey } from "./aiFixApplication";
import { normalizeBareColumn } from "./stagingGridCellValue";

export const STAGING_ISSUE_LABELS = {
    TYPE_MISMATCH: "Type mismatch — value cannot be stored in the target field type",
    MANDATORY_MISSING: "Missing mandatory value",
    VALUE_OUT_OF_RANGE: "Value exceeds the target field length",
};

export const STAGING_ISSUE_TYPE_LABELS = {
    TYPE_MISMATCH: "Type mismatch",
    MANDATORY_MISSING: "Missing value",
    VALUE_OUT_OF_RANGE: "Value out of range",
};

const matchesColumn = (issueColumn, bareColumn) =>
    issueColumn === bareColumn
    || `CDM_CustomCSV.${issueColumn}` === bareColumn;

export const stagingClbIdKey = (id) => {
    if (id == null || id === "") return null;
    return String(id);
};

export const stagingRowClbId = (row) => {
    if (!row) return null;
    return row.CLB_ID ?? row.clb_id ?? row["CDM_CustomCSV.CLB_ID"] ?? row.id ?? null;
};

export const errorRowIdKeysFromIssues = (issueRows) => {
    const ids = new Set();
    for (const row of issueRows || []) {
        const hasError = (row.issues || []).some((issue) => issue.severity === "error");
        if (!hasError) continue;
        const key = stagingClbIdKey(row.clb_id);
        if (key) ids.add(key);
    }
    return ids;
};

export const filterStagingItemsToErrorRows = (items, errorIdKeys) => {
    if (!errorIdKeys) return items;
    return (items || []).filter((item) => errorIdKeys.has(stagingClbIdKey(stagingRowClbId(item))));
};

export const getCellIssuesForColumn = (issuesByClbId, clbId, bareColumn) => {
    if (clbId == null) return [];
    const cellIssues = issuesByClbId.get(clbId)
        || issuesByClbId.get(stagingClbIdKey(clbId))
        || [];
    return cellIssues.filter((issue) => matchesColumn(issue.column, bareColumn));
};

export const buildCellIssuesByKey = (rows = [], suggestionCellKeys = new Set()) => {
    const details = new Map();
    for (const row of rows) {
        const clbId = row.clb_id;
        for (const issue of row.issues || []) {
            if (issue.severity !== "error") continue;
            const bareColumn = normalizeBareColumn(issue.column);
            const key = fixKey(clbId, bareColumn);
            if (suggestionCellKeys.has(key)) continue;
            const existing = details.get(key) || [];
            existing.push(issue);
            details.set(key, existing);
        }
    }
    return details;
};

export const formatStagingIssueActual = (issue) => {
    if (issue.actual != null && issue.actual !== "") return String(issue.actual);
    if (issue.actual_length != null) return String(issue.actual_length);
    return "—";
};
